<script setup>
import { useI18n } from 'vue-i18n';
import PostSaleAgendaCaseCard from './PostSaleAgendaCaseCard.vue';

defineProps({
  cases: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['action', 'open']);
const { t } = useI18n();
</script>

<template>
  <div
    data-testid="post-sale-agenda-day-list"
    class="divide-y divide-lais-border-soft"
  >
    <template v-if="loading">
      <article
        v-for="index in 3"
        :key="index"
        class="grid min-h-[130px] gap-3 bg-white px-8 py-7"
      >
        <div class="h-5 w-2/5 animate-pulse rounded bg-lais-bg-soft" />
        <div class="h-9 animate-pulse rounded bg-lais-bg-soft" />
        <div class="h-9 w-36 animate-pulse rounded bg-lais-bg-soft" />
      </article>
    </template>
    <p
      v-else-if="!cases.length"
      class="border-dashed border-lais-border p-8 text-center text-sm text-lais-text-muted"
    >
      {{ t('POST_SALE.AGENDA.EMPTY') }}
    </p>
    <PostSaleAgendaCaseCard
      v-for="postSaleCase in cases"
      :key="postSaleCase.id"
      :post-sale-case="postSaleCase"
      @action="emit('action', $event)"
      @open="emit('open', $event)"
    />
  </div>
</template>
